module.exports = __webpack_public_path__ + "media/images/icon_moon-764558b3393652dafe97e7501eb813ea.svg";